"use strict";
// Copied from https://github.com/Sanyaku/prada/blob/master/packages/yama-styles/src/ColorsV2.ts.
// We will need to update this file as the linked file gets updated.
Object.defineProperty(exports, "__esModule", { value: true });
var YamaColors;
(function (YamaColors) {
    // Brand base Colors
    YamaColors["black-10"] = "#7E8EA6";
    YamaColors["black-20"] = "#687B96";
    YamaColors["black-30"] = "#546685";
    YamaColors["black-40"] = "#435575";
    YamaColors["black-50"] = "#344666";
    YamaColors["black-60"] = "#233654";
    YamaColors["black-70"] = "#1D2B45";
    YamaColors["black-80"] = "#1A253B";
    YamaColors["black-90"] = "#151E30";
    YamaColors["black-100"] = "#101827";
    YamaColors["grey-10"] = "#CEDEEB";
    YamaColors["grey-20"] = "#B6C9D9";
    YamaColors["grey-30"] = "#9DB4C7";
    YamaColors["grey-40"] = "#84A1B8";
    YamaColors["grey-50"] = "#6D8DA6";
    YamaColors["grey-60"] = "#517691";
    YamaColors["grey-70"] = "#3C6482";
    YamaColors["grey-80"] = "#315775";
    YamaColors["grey-90"] = "#2E506B";
    YamaColors["grey-100"] = "#244159";
    YamaColors["white-10"] = "#FFFFFF";
    YamaColors["white-20"] = "#FAFAFA";
    YamaColors["white-30"] = "#F5F8FA";
    YamaColors["white-40"] = "#EBEFF2";
    YamaColors["white-50"] = "#E6EAED";
    YamaColors["white-60"] = "#DFE4E8";
    YamaColors["white-70"] = "#D5DADE";
    YamaColors["white-80"] = "#C9D0D6";
    YamaColors["white-90"] = "#B9C2C9";
    YamaColors["white-100"] = "#B0B8BF";
    YamaColors["primary-10"] = "#E3EDFF";
    YamaColors["primary-20"] = "#C9DDFF";
    YamaColors["primary-30"] = "#A0C1FA";
    YamaColors["primary-40"] = "#6A9EF7";
    YamaColors["primary-50"] = "#4885F0";
    YamaColors["primary-60"] = "#2063D6";
    YamaColors["primary-70"] = "#1D59C2";
    YamaColors["primary-80"] = "#0944AB";
    YamaColors["primary-90"] = "#093582";
    YamaColors["primary-100"] = "#002970";
    // Feedback Brand Color
    YamaColors["critical-10"] = "#FCE7E6";
    YamaColors["critical-20"] = "#FFD8D6";
    YamaColors["critical-30"] = "#F7ABA6";
    YamaColors["critical-40"] = "#F77D74";
    YamaColors["critical-50"] = "#F75A4F";
    YamaColors["critical-60"] = "#D63A2E";
    YamaColors["critical-70"] = "#BF2206";
    YamaColors["critical-80"] = "#A61C00";
    YamaColors["critical-90"] = "#851600";
    YamaColors["critical-100"] = "#701300";
    YamaColors["warning-10"] = "#F7F4C3";
    YamaColors["warning-20"] = "#F5E99F";
    YamaColors["warning-30"] = "#E3C45F";
    YamaColors["warning-40"] = "#E39F22";
    YamaColors["warning-50"] = "#D67302";
    YamaColors["warning-60"] = "#C95100";
    YamaColors["warning-70"] = "#AD3D00";
    YamaColors["warning-80"] = "#943400";
    YamaColors["warning-90"] = "#782A00";
    YamaColors["warning-100"] = "#662400";
    YamaColors["success-10"] = "#E3F7CD";
    YamaColors["success-20"] = "#D3F2B1";
    YamaColors["success-30"] = "#A5D96F";
    YamaColors["success-40"] = "#78BD31";
    YamaColors["success-50"] = "#569E0D";
    YamaColors["success-60"] = "#348700";
    YamaColors["success-70"] = "#2C7300";
    YamaColors["success-80"] = "#256100";
    YamaColors["success-90"] = "#1D4D00";
    YamaColors["success-100"] = "#1A4500";
    // Accent brand colors
    YamaColors["ocean-10"] = "#DDF0F9";
    YamaColors["ocean-20"] = "#BAE3F5";
    YamaColors["ocean-30"] = "#7FCAEB";
    YamaColors["ocean-40"] = "#3EAEDE";
    YamaColors["ocean-50"] = "#0692CF";
    YamaColors["ocean-60"] = "#0072A3";
    YamaColors["ocean-70"] = "#03658F";
    YamaColors["ocean-80"] = "#005275";
    YamaColors["ocean-90"] = "#003E59";
    YamaColors["ocean-100"] = "#00344D";
    YamaColors["evergreen-10"] = "#DAF2E4";
    YamaColors["evergreen-20"] = "#B9EBCD";
    YamaColors["evergreen-30"] = "#82CFA1";
    YamaColors["evergreen-40"] = "#55B57B";
    YamaColors["evergreen-50"] = "#2B9E59";
    YamaColors["evergreen-60"] = "#058036";
    YamaColors["evergreen-70"] = "#0F6E35";
    YamaColors["evergreen-80"] = "#075928";
    YamaColors["evergreen-90"] = "#02451D";
    YamaColors["evergreen-100"] = "#003816";
    YamaColors["magenta-10"] = "#FCE8F5";
    YamaColors["magenta-20"] = "#FFCFED";
    YamaColors["magenta-30"] = "#F5A6D8";
    YamaColors["magenta-40"] = "#F07AC5";
    YamaColors["magenta-50"] = "#DB53A9";
    YamaColors["magenta-60"] = "#C2308D";
    YamaColors["magenta-70"] = "#B31077";
    YamaColors["magenta-80"] = "#940760";
    YamaColors["magenta-90"] = "#730049";
    YamaColors["magenta-100"] = "#61003D";
    // brand colors
    YamaColors["Sumo-Logic-Blue"] = "#000099";
    YamaColors["Royal-Blue"] = "#0046BE";
    YamaColors["Ocean"] = "#0092D2";
    YamaColors["Teal"] = "#21B9CC";
    YamaColors["Powder-Blue"] = "#E5F4FA";
    YamaColors["Forrest-Green"] = "#00492D";
    YamaColors["Evergreen"] = "#007E33";
    YamaColors["Jade"] = "#279F00";
    YamaColors["Lime"] = "#A0CC00";
    YamaColors["Maroon"] = "#510021";
    YamaColors["Magenta"] = "#C6007E";
    YamaColors["Dark-Gray"] = "#64696C";
    YamaColors["Gray"] = "#8C9296";
    YamaColors["Light-Gray"] = "#F1F1F1";
    // Note: this was not in the original file, and was added for CSIEM specifically.
    YamaColors["Platinum"] = "#F1F4F5";
})(YamaColors || (YamaColors = {}));
exports.default = YamaColors;
